import { storyblokEditable } from "@storyblok/react";
import Link from "@components/core/Link";
import { StoryblokPicture } from "@components/core/Storyblok/StoryblokImage";

function LargeBannerSlide({ blok, onClick, isFirst }) {
  return (
    <Link
      {...storyblokEditable(blok)}
      href={blok.link?.url}
      prefetch={false}
      onClick={onClick}
      className="large-banner-slider-link"
    >
      <StoryblokPicture
        className="large-banner-slider-image"
        desktopSrc={blok.background_image_desktop?.filename}
        mobileSrc={blok.background_image_mobile?.filename}
        loading={isFirst ? "eager" : "lazy"}
      />
    </Link>
  );
}

export default LargeBannerSlide;
